import HiddenInput from "@/components/form/components/HiddenInput";
import { setErrorsToForm } from "@/utils/formUtils";
import { validations } from "@/utils/validationUtils";
import { Alert, Form, Modal } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useUpdateParentAgent } from "../../../../common/api/queries";
import { ModalSizes } from "../../../../common/constants";
import { useCurrentAgentAccount } from "../../../auth/hooks";
import { AgentSelect } from "../../../enumerations/components/form/AgentSelect";
import { Agent, UpdateAgentParent } from "../../types";

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  agent: Agent;
};

export const AgentParentModalForm = ({ isOpen, onCancel, agent }: Props) => {
  const { t } = useTranslation();

  const currentAgentAccount = useCurrentAgentAccount();

  const [form] = Form.useForm<UpdateAgentParent>();

  const updateParentAgent = useUpdateParentAgent();

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue({ optimisticLockVersion: agent.optimisticLockVersion, parentId: agent.parent?.id });
    }
  }, [isOpen, agent]);

  const handleFormSubmit = () => {
    form.validateFields().then((values) => {
      updateParentAgent.mutate(
        { id: agent.id, object: values },
        {
          onSuccess: onCancel,
          onError: (error) => setErrorsToForm(form, "agent.attrs", error.violations),
        },
      );
    });
  };

  return (
    <Modal
      width={ModalSizes.TINY}
      open={isOpen}
      title={t("agent.titles.updateAgentParent")}
      cancelText={t("common.cancel")}
      okText={t("common.save")}
      confirmLoading={updateParentAgent.isPending}
      afterClose={() => form.resetFields()}
      onOk={handleFormSubmit}
      onCancel={onCancel}
      mask={{ closable: false }}
    >
      <Form form={form} layout="vertical" name="updateParentAgent">
        <HiddenInput name="optimisticLockVersion" />

        <Form.Item name="parentId" label={t("agent.attrs.parentId")} rules={[validations.notNull]}>
          <AgentSelect
            optionsProps={{ subordinateTreePath: currentAgentAccount?.agent.accessTreePath, excludedIds: [agent.id] }}
          />
        </Form.Item>
      </Form>

      <Alert type="info" title={t("agent.helpers.updateAgentParentWarning")} />
    </Modal>
  );
};
